export enum RailingStyle {
  RailCenteredAtEnd = 'rail-centered-at-end',
  CrossRailing = 'cross-railing',
  DakotaRailing = 'dakota-railing',
  PoolBarCounter = 'pool-bar-counter',
  PremierRailing = 'premier-railing',
  RoundRailing = 'round-railing',
  None = 'none',
}
